const nullReservation = {
  reservationId: null,
  reservationPrice: 0,
  reservationTaxRate: 0,
  playerReservationId: null,
  player: {},
}

const initialState = {
  ...nullReservation,
  items: [],
  discount: {type: "amount", amount: 0.0}
}

const loadInitialState = () => {
  const state = {...initialState}
  const shopData = window.App.shop
  if (!shopData) return state
  if (shopData.player_reservation_id) {
    state.playerReservationId = shopData.player_reservation_id
    state.reservationId = shopData.reservation_id
    state.reservationPrice = shopData.reservation_price
    state.reservationTaxRate = shopData.reservation_tax_rate
  }
  return state
}

const findItemIndex = (state, productId) => {
  const index = state.items.findIndex(item => item.productId === productId);
  return {item: state.items[index], index}
}

const handleAddCartItem = (state, productId) => {
  const {item, index} = findItemIndex(state, productId);
  var newCartItems;
  if (index != -1) {
    const discount = state.items[index].discount
    newCartItems = [
      ...state.items.slice(0, index),
      {productId, quantity: item.quantity + 1, discount: discount},
      ...state.items.slice(index + 1, state.items.length)
    ]
  } else {
    newCartItems = [
      ...state.items,
      {productId, quantity: 1}
    ]
  }
  return {...state, items: newCartItems}
}

const handleAddUncategorizedCartItem = (state, uncategorizedPrice) => {
  var newCartItems = [
    ...state.items,
    {productId: "UNCATEGORIZED", quantity: 1, price: uncategorizedPrice}
  ]
  return {...state, items: newCartItems}
}

const handleDeleteCartItem = (state, productId, index) => {
  const item = state.items[index]
  const newQuantity = item.quantity - 1;
  let newCartItems = [...state.items.slice(0, index)]
  if (newQuantity) {
    newCartItems.push({productId, quantity: newQuantity, discount: state.items[index].discount});
  }
  newCartItems = newCartItems.concat([...state.items.slice(index + 1, state.items.length)])
  if (newCartItems.length == 0) {
    return {...state, items: newCartItems, discount: {type: "amount", amount: 0}}
  }
  return {...state, items: newCartItems}
}

const updatePlayer = (state, payload) => {
  const player = {...state.player}
  if (payload.id) player.id = payload.id
  if (payload.firstName) player.firstName = payload.firstName
  if (payload.lastName) player.lastName = payload.lastName
  if (payload.phoneNumber) player.phone = payload.phoneNumber
  if (payload.countryCode) player.countryCode = payload.countryCode
  if (payload.email) player.email = payload.email
  return {...state, player}
}

const calcPercentageDiscount = (prevValue, newValue) => {
  const amount = parseFloat((prevValue).toString() + newValue)
  return amount > 100 ? newValue : amount
}

const calcAmountDiscount = (prevValue, newValue) => {
  const amount = parseFloat((prevValue * 100).toFixed(0).toString() + newValue) / 100
  return amount.toFixed(2)
}

const addTotalDiscount = (state, payload) => {
  const type = payload.discount.type
  const prevAmount = (state.discount.type !== type) ? 0 : state.discount.amount
  const newAmount = payload.discount.amount
  const amount = (type == "percentage") ? calcPercentageDiscount(prevAmount, newAmount) : calcAmountDiscount(prevAmount, newAmount)

  return {...state, discount: {type: type, amount: amount}}
}

const correctTotalDiscount = (state) => {
  const amount = state.discount.amount.toString()
  let newAmount = amount.length == 1 ? 0 : parseFloat(amount.slice(0, -1))
  newAmount = state.discount.type == "percentage" ? newAmount : (newAmount / 10).toFixed(2)

  return {...state, discount: {type: state.discount.type, amount: newAmount}}
}

const addLocalDiscount = (state, payload) => {
  const index = payload.index
  const prevDiscount = state.items[index].discount || {}
  const type = payload.discount.type
  const prevAmount = (prevDiscount.type !== type) ? 0 : prevDiscount.amount
  const newAmount = payload.discount.amount
  const amount = (type == "percentage") ? calcPercentageDiscount(prevAmount, newAmount) : calcAmountDiscount(prevAmount, newAmount)

  const newCartItems = [
    ...state.items.slice(0, index),
    { ...state.items[index], discount: {type: type, amount: amount} },
    ...state.items.slice(index + 1, state.items.length)
  ]
  return {...state, items: newCartItems}
}

const correctLocalDiscount = (state, index) => {
  const prevAmount = state.items[index].discount.amount.toString()
  const dicountType = state.items[index].discount.type
  let newAmount = parseFloat(prevAmount.slice(0, -1) || 0)
  newAmount = (dicountType == "percentage") ? newAmount : (newAmount / 10).toFixed(2)

  const newCartItems = [
    ...state.items.slice(0, index),
    { ...state.items[index], discount: {type: dicountType, amount: newAmount}},
    ...state.items.slice(index + 1, state.items.length)
  ]
  return {...state, items: newCartItems}
}

const cart = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SHOP.INIT":
    case "PAYMENT_MODAL.INIT":
    case "CLEAR_SHOP":
      return loadInitialState();
    case "SHOP_CART_ADD_ITEM":
      return handleAddCartItem(state, payload.id);
    case "SHOP_CART_ADD_UNCATEGORIZED_PRODUCT":
      return handleAddUncategorizedCartItem(state, payload.amount);
    case "SHOP_CART_REMOVE_ITEM":
      return handleDeleteCartItem(state, payload.id, payload.index);
    case "SHOP_CART_ADD_RESERVATION":
    case "SHOP_CART.LOAD":
      return {...state, ...payload}
    case "SHOP_CART.REMOVE_RESERVATION":
      return {...state, ...nullReservation}
    case "PAYMENT_MODAL_PLAYER_CHANGED":
      return updatePlayer(state, payload)
    case "OPEN_ORDER.NAME_CONFIRMED":
    case "OPEN_ORDER.CLOSE_TITLE":
    case 'ORDER.TOUCHLESS_ORDER_CLOSED':
      return initialState
    case "SHOP_CART_ADD_DISCOUNT":
      return payload.index == -1 ? addTotalDiscount(state, payload) : addLocalDiscount(state, payload)
    case "SHOP_CART_CORRECT_DISCOUNT":
      return payload.index == -1 ? correctTotalDiscount(state) : correctLocalDiscount(state, payload.index)
    default:
      return state
  }
}

export default cart
